import { useTranslation } from 'react-i18next';
import SearchResultsHeader from '../SearchResultsHeader';
import SortByFilter from '../../../SearchFilters/SortByFilter';
import React from 'react';
import { SearchFilters } from '../../../../types/search';
import useRouter from '../../../../utils/useRouter';
import useQueryModification from '../../../../routes/SearchPage/useQueryModification';
import { searchSettings } from '../../../../constants';

export type SearchResultsTopbarOldUIProps = {
  total: number;
  loadedCount: number;
  requestFilters: SearchFilters;
  isLoaded: boolean;
};

const SearchResultsTopbarOldUI: React.FC<SearchResultsTopbarOldUIProps> = ({
  total,
  loadedCount,
  requestFilters,
  isLoaded = false,
}) => {
  const { t } = useTranslation();
  const { router, match } = useRouter();
  const { updateQueryParams } = useQueryModification<SearchFilters>(
    router,
    match
  );

  const text = total === 1 ? t('Result') : t('Results');
  return (
    <div className='search-results__topbar'>
      <div
        className='search-results__header'
        data-testid='search-results-header-old-ui'
      >
        {!isLoaded ? null : (
          <SearchResultsHeader
            totalText={`${total} ${text}`}
            loadedCount={loadedCount}
          />
        )}
      </div>
      <div className='search-results__sort' data-testid='sort-by-filter'>
        <SortByFilter
          currentValue={requestFilters.sortBy}
          updateFilter={(sortBy) => updateQueryParams({ sortBy })}
          clearFilter={() =>
            updateQueryParams({ sortBy: searchSettings.defaultSortBy })
          }
        />
      </div>
    </div>
  );
};

export default SearchResultsTopbarOldUI;
